import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { stopPropagation } from '../../../lib/_util/EventManager';
import { SELECTION_KEY } from './TableStore';
import ObserverCheckBox from '../check-box/CheckBox';
const SelectionTreeBox = observer(function SelectionTreeBox(props) {
    const { record } = props;
    const handleChange = useCallback((value) => {
        const { dataSet } = record;
        if (dataSet) {
            if (value) {
                dataSet.treeSelect(record);
            }
            else {
                dataSet.treeUnSelect(record);
            }
        }
    }, [record]);
    return (React.createElement(ObserverCheckBox, { checked: record.isSelected, onChange: handleChange, onClick: stopPropagation, disabled: !record.selectable, "data-selection-key": SELECTION_KEY, indeterminate: record.isSelectionIndeterminate, value: true }));
});
SelectionTreeBox.displayName = 'SelectionTreeBox';
export default SelectionTreeBox;
